import { Options, Vue } from "vue-class-component";

@Options({
    name: "edit-icon",
})
export default class EditIcon extends Vue {
}
